import { SET_EDIT, SET_UNEDIT } from '../../constant';

const dutyEditFlag = (State = false, action = {}) => {
  const { type } = action;
  switch (type) {
    case SET_EDIT:
      return true;
    case SET_UNEDIT:
      return false;
    default:
      return State;
  }
};

export { dutyEditFlag };
